module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Waiting-For-Server'), _vm._v(" "), _c('Global-Message'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('Footer-Block')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8399f25c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8399f25c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 796
// module chunks = 3